import React from "react";
import { LoadioDeviceListTemplate } from "themes/administration/loadio/pages";
import { LoadioDeviceListViewStore } from "administration/loadio/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new LoadioDeviceListViewStore(rootStore, componentProps),
    "loadioDeviceListViewStore"
)
class LoadioDeviceList extends React.Component {
    render() {
        return <LoadioDeviceListTemplate {...this.props} />;
    }
}

export default LoadioDeviceList;
